// extracted by mini-css-extract-plugin
export default {"start-board":"StartGame_start-board__9sUz5","start-game":"StartGame_start-game__SV3ct","start-game-modal":"StartGame_start-game-modal__syzUU"};